import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  convertTo12HourFormat,
  currentMonthEndDate,
  currentMonthStartDate,
} from "../../../common-data/Converts";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import FullCalendarReact from "../../../components-react/FullCalendarReact";
import { CheckCircleIcon, XCircleIcon } from "../../../../images/icons/icons";
import "../../../../styles/attendance/calendar-attendance-report.css";
import { fetchLateCheckinsStatsData } from "../../../../redux/reducers/apiSlice";
import LateCheckinStats from "./LateCheckinStats";

const LateCheckinCalenderLogs = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const iniAllFilters = {
    selStartDate: currentMonthStartDate,
    selEndDate: currentMonthEndDate,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    // half_day: true,
    date_from: allFilters.selStartDate || "",
    date_to: allFilters.selEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [calAttendanceData, setCalAttendanceData] = useState([]);

  function getLateCheckinsStat(filters) {
    dispatch(
      fetchLateCheckinsStatsData({
        filters: { user_id: rowData.user_id, ...filters },
        token: userInfoData?.token,
      })
    );
  }

  function getCalViewAttendace(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: `/attandance/late-checkin/${rowData?.user_id}`,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (rowData?.user_id) {
      getLateCheckinsStat(filters);
      getCalViewAttendace(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      date_from: allFilters.selStartDate,
      date_to: allFilters.selEndDate,
    }));
  }, [allFilters]);

  useEffect(() => {
    if (!loading && data?.status && data?.data) {
      setCalAttendanceData(data?.data);
    } else {
      setCalAttendanceData([]);
    }
  }, [data, loading]);

  const formatAttendanceDataForCalendar = (data) => {
    return data.map((item) => ({
      id: item.uid,
      title: item.name || "Late Check-in",
      start: item.date.split("-").reverse().join("-"),
      extendedProps: { ...item },
    }));
  };

  const renderEventContent = useCallback((eventInfo) => {
    const {
      actual_checkin_time,
      actual_checkout_time,
      time_difference,
      half_day,
      shift_details,
    } = eventInfo.event.extendedProps;

    return (
      <div className="cal-view-grid-container staff-attendance-cal-view-container">
        <div className="cal-attendance-data">
          <div className="shift-box">
            <span className="shift-name">Shift Details</span>
          </div>

          <div className="checkin-checkout-box-divider">
            <div className="checkin-checkout-box">
              <div className="checkin-box checkout">
                <span className="label">Checkin</span>
                <span className="time">{actual_checkin_time || "-"}</span>
              </div>

              <div className="gray-line-long"></div>

              <div className="checkin-box checkin">
                <span className="label">Checkout</span>
                <span className="time">{actual_checkout_time || "-"}</span>
              </div>
            </div>

            <div className="checkin-checkout-box">
              <div className="checkin-box checkin">
                <span className="label">Late By</span>
                <span className="time" style={{ color: "#CC0A39" }}>
                  {time_difference || 0} min
                </span>
              </div>

              <div className="gray-line-long"></div>

              <div className="checkin-box checkout">
                <span className="label">Half Day</span>
                <span className="time">
                  {half_day ? <CheckCircleIcon /> : <XCircleIcon />}
                </span>
              </div>
            </div>
          </div>
        </div>

        {shift_details?.map((shift, index) => {
          const { shift_name, start_time, end_time, status } = shift || {};

          const startTime = start_time ? convertTo12HourFormat(start_time) : "";
          const endTime = end_time ? convertTo12HourFormat(end_time) : "";

          return (
            <div className="cal-attendance-data" key={index}>
              <div className="shift-box">
                <span className="shift-name">
                  shift {index + 1} ({shift_name || ""})
                </span>
              </div>

              <div className="checkin-checkout-box">
                <div className="checkin-box checkin">
                  <span className="label">Start</span>
                  <span className="time">{startTime || "-"}</span>
                </div>

                <div className="gray-line-long"></div>

                <div className="checkin-box checkout">
                  <span className="label">End</span>
                  <span className="time">{endTime || "-"}</span>
                </div>
              </div>

              {/* <span
                className="status"
                style={{
                  color: status !== "active" ? "#CC0A39" : "#3B66D6",
                }}>
                {status || ""}
              </span> */}
            </div>
          );
        })}
      </div>
    );
  }, []);

  // console.log(calAttendanceData, " <=calAttendanceData=> ");

  return (
    <>
      <LateCheckinStats />

      <div className="calender-view-checkins-container">
        <div className="calender-view-checkins big-calendar-container">
          <FullCalendarReact
            events={formatAttendanceDataForCalendar(calAttendanceData)}
            setCurrentMonth={setAllFilters}
            renderEventContent={renderEventContent}
          />
        </div>
      </div>
    </>
  );
};

export default LateCheckinCalenderLogs;
